export const environment:any = {
    production:true,
    // Prod
    basePath : 'https://bepc-tlm.in',
    basePort:'/DispatchAPI/',
    baseReportPath : 'https://bepc-tlm.in',
    baseReportPort:'/DispatchSSRS_API/'

    // basePath : 'https://bepc-tlm.in',
    // basePort:'/NsdcdemoAPI/',
    // baseReportPath : 'https://bepc-tlm.in',
    // baseReportPort:'/Nsdcdemo_ssrs_api/'
};
